export default "__VITE_ASSET__3300d6e4__"